export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-model-1200-a579472233724c9a54b70609bdf3c63b.png";